import TemplateSimple from './TemplateSimple';

export default TemplateSimple;
